import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {Matrix} from '../message/Matrix';

export class MatrixWrapper extends BaseWrapper<Matrix, BasicCriteria, BasicScenario>  {}

